@if (!loading()) {
  <router-outlet></router-outlet>
}
<cfp-loading-spinner [loading]="loading()" [attr.data-test]="loading() ? 'appStarting' : undefined" />
@if (useCustomerStyling()) {
  <cfp-customer-styling />
}
